const DOM = {
    positionBox: document.getElementById("position_box"),
    applyCareer: document.getElementById("apply_career"),
    showBtn: document.getElementById("show_btn"),
};

		let emptyArr = [];
		let limit = 3;
		let offset = 0;
		let loaded = false; // ← prevents duplicate calls on re-observe

		const career = (lim, off) => {
			fetch(`${process.env.APIURL}/blog/api/open-positions?limit=${lim}&offset=${off}`)
				.then(response => response.json())
				.then(data => {
					offset += 3;
					const results = data?.data?.results || [];
					emptyArr.push(...results);

					if (DOM.positionBox && results.length) {
						const fragment = document.createDocumentFragment();

						results.forEach(job => {
							const date = new Intl.DateTimeFormat("en-US").format(new Date(job.updated_at));
							const node = document.createElement("div");
							node.style.cursor = "pointer";
							node.classList.add("bg-violet");
							node.id = job.id;
							node.innerHTML = `
								<div class="col-span-1 w-full py-8 lg:px-14 px-4 border-b transition duration-150 ease-out hover:ease-in relative all_vaccancy">
									<div class="flex items-center justify-between">
										<div>
											<p class="xl:text-base text-sm Gilroy-semiBold opacity-80">${date}</p>
											<h3 class="xl:text-2xl text-lg Gilroy-semiBold capitalize text-white">${job.title}</h3>
											<p class="mt-4 lg:mt-0">
												<span class="text-base Gilroy-semiBold opacity-80">
													${job.max_experience !== "None"
														? `${job.min_experience} - ${job.max_experience} Year Experience`
														: `${job.min_experience} + Year Experience`}
												</span>
											</p>
										</div>
										<div class="text-base capitalize Gilroy-Medium border-white border-1 border px-5 py-2">view detail</div>
									</div>
								</div>`;
							fragment.appendChild(node);
						});

						DOM.positionBox.appendChild(fragment);
						results.forEach(job => initializeEvent(job.id));
					}

					if (DOM.applyCareer) {
						DOM.applyCareer.classList.remove("block");
						DOM.applyCareer.classList.add("hidden");
					}

					if (DOM.showBtn && (emptyArr.length === 0 || emptyArr.length === data?.data?.count)) {
						DOM.showBtn.classList.add("hidden");
					}
				})
				.catch(err => console.error("career() error:", err));
		};

		function initializeEvent(id) {
			const viewEle = document.getElementById(id);
			if (viewEle) {
				viewEle.onclick = () => {
					const url = new URL("/apply-career", window.location.origin);
					url.searchParams.append("id", id);
					window.open(url.href, "_self");
				};
			}
		}

		// ✅ Trigger fetch only when #position_box scrolls into view
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting && !loaded) {
					loaded = true;
					career(limit, offset);
					observer.disconnect(); // ← stop observing after first load
				}
			});
		}, { rootMargin: "100px" }); // ← starts loading 100px before it's visible

		if (DOM.positionBox) observer.observe(DOM.positionBox);

		window.BTNN = () => career(limit, offset);